export default __webpack_public_path__ + "static/tanmai-b0f4affb11c0b480b6975820fa2914c9.png";